/* eslint-disable max-len */
import { FC, Fragment } from 'react';
import { formatPrice } from 'utils/hooks/usePrice';

import EmptyState from '~components/ui/EmptyState';
import usePurchase from '~utils/hooks/usePurchase';

import { Ticket } from '~types';

import TicketRow from './TicketRow';
import styles from './Tickets.module.css';

interface Props {
  ticketsPrices: Ticket[];
  locked?: boolean;
}

const Empty = () => (
  <div className={styles.empty}>
    <EmptyState
      type="seat"
      title="Selecciona un asiento"
      description="Aqui aparecerán los asientos que elegiste, el tipo de boleto y el precio."
    />
  </div>
);

const Tickets: FC<Props> = ({ ticketsPrices, locked = false }) => {
  const { tickets, total, removeSeat, updateTicketSeat, bookingFee } = usePurchase();
  if (typeof window === 'undefined') {
    return null;
  }
  return (
    <div className={styles.root}>
      {(() => {
        if (tickets.length < 1) {
          return <Empty />;
        }

        return (
          <Fragment>
            {tickets.map((ticket) => (
              <TicketRow
                key={ticket.id}
                data={ticket}
                ticketsPrices={ticketsPrices}
                locked={locked}
                onRemove={(ticketId) => {
                  removeSeat(ticketId);
                }}
                onChange={(item) => {
                  updateTicketSeat(item);
                }}
              />
            ))}

            <div className={styles.totalSection}>
              {!!tickets?.length && !!bookingFee && (
                <div className={styles.totalRow}>
                  <span className="text-sm">Cargo por servicio:</span>
                  <span className="font-bold">
                    {formatPrice((bookingFee || 0) * tickets.length)}
                  </span>
                </div>
              )}
              <div className={styles.totalRow}>
                <span className="text-sm">Total (incluye IVA):</span>
                <span className={styles.totalCost}>{formatPrice(total)}</span>
              </div>
            </div>
          </Fragment>
        );
      })()}
    </div>
  );
};
export type TicketsComponent = typeof Tickets;
export default Tickets;
